import axios from 'axios'

interface Company {
  company: CompanyDetails
}

interface CompanyDetails {
  id: number
  name: string
}

interface IFindUserResponse {
  status: string
  data: Company
}

interface IData {
  name?: string
  operativeId?: number
  typeCompanyId?: number
  contactName?: string
  contactEmail?: string
  phone?: string
  logo?: Blob | null
  hasIntegration?: string
  integrationType?: number
  commercialInCharge?: string
  companyCategory?: number
  industryType?: string
  usesAi?: boolean
  workModel?: string
  marketComplexity?: string
  lifeCycle?: string
  hrMaturityLevel?: string
  hasQuestionnaireManagement?: string
  mfaEnabled?: string
  descriptiveMapsEnabled?: boolean
}

/**
 * @description service to edit a company
 * @param data
 * @param idCompany
 */
const editCompany = async (data: IData, idCompany: number) => {
  const {
    name,
    typeCompanyId,
    contactName,
    contactEmail,
    phone,
    operativeId,
    logo,
    hasIntegration,
    integrationType,
    commercialInCharge,
    companyCategory,
    industryType,
    usesAi,
    workModel,
    marketComplexity,
    lifeCycle,
    hrMaturityLevel,
    hasQuestionnaireManagement,
    mfaEnabled,
    descriptiveMapsEnabled,
  } = data

  const body = new FormData()
  if (name) body.append('name', name)
  if (typeCompanyId) body.append('type_company_id', typeCompanyId.toString())
  if (contactName) body.append('contact_name', contactName)
  if (contactEmail) body.append('contact_email', contactEmail)
  if (phone) body.append('phone', phone)
  if (operativeId) body.append('operative_id', operativeId.toString())
  if (logo) body.append('logo', logo, 'logo.png')
  if (hasIntegration) body.append('has_integration', hasIntegration)
  if (integrationType) body.append('integration_type', integrationType.toString())
  if (commercialInCharge) body.append('commercial_name', commercialInCharge)
  if (companyCategory) body.append('category_id', companyCategory.toString())
  if (industryType) body.append('industry_type_id', industryType.toString())
  if (workModel) body.append('work_model', workModel)
  if (marketComplexity) body.append('market_complexity_id', marketComplexity)
  if (lifeCycle) body.append('life_cycle_id', lifeCycle)
  if (hrMaturityLevel) body.append('hr_maturity_level_id', hrMaturityLevel)
  if (hasQuestionnaireManagement) {
    body.append('has_questionnaire_management', hasQuestionnaireManagement)
  }
  if (mfaEnabled) body.append('mfa_enabled', mfaEnabled)
  body.append('descriptive_maps_enabled', (descriptiveMapsEnabled ?? false).toString())
  body.append('uses_ai', (usesAi ?? false).toString())

  const res: IFindUserResponse = await axios
    .put(`/company/${idCompany}`, body, {
      headers: {
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return { ok: false, message: error.message }
    })
  return res
}

export default editCompany
